// export const environment = {
//   production: true,
//   apiUrl: 'https://api.hadsup.com',
//   front_url:'https://hadsup.com/',
//   dashboard_url:'https://app.hadsup.com/',
// };
export const environment = {
  production: true,
  apiUrl: 'https://api.hadsup.com',
  front_url:'https://hadsup.com/',
  dashboard_url:'https://app.hadsup.com/',
  hadsup_home_url:'https://www.hadsup.com/',
  mapApi: 'AIzaSyBEPWq6Hd5E0JS0lcpxaYl_Jt-TXY5NPaE',
};
